import { Injectable, Renderer2 } from "@angular/core";
import { async } from "@angular/core/testing";
import { environment } from "src/environments/environment";
import { resolve } from "url";


/** Getting Captcha url response */
declare var grecaptcha: any;
/** Captcha Service */
@Injectable({
  providedIn: "root",
})
export class CaptchaService {
  /** Method to initialize component */
  constructor() {}

  
  /**
   * Initiate script for captcha
   * @param _renderer Angular's Renderer2 instance used to interact with the DOM.
   */
  initiateCaptchaScript(_renderer: Renderer2): void {
    const isScriptAppended = !!document.getElementById('g-captcha');

    if(!isScriptAppended) {
      const script = _renderer.createElement("script") as HTMLScriptElement;
  
      script.src = `https://www.google.com/recaptcha/api.js?render=${environment.gcaptchaKey}`;
  
      script.id = "g-captcha";
      
  
      _renderer.appendChild(document.body, script);
    }
  }

  /**
   * Submit captcha and generate response
   * @returns {Promise<string>} Generated response string from captcha
   */
  async checkCaptcha(): Promise<string> {
    return new Promise(async(res, rej) => {
      if(typeof grecaptcha === 'undefined'){
        
       await new Promise((res,rej)=>{
          document.getElementById('g-captcha').onload = res
        })
      }
      grecaptcha.ready(async function () {
        res(
          await grecaptcha.execute(`${environment.gcaptchaKey}`, {
            action: "submit",
          })
        );
      });
    });
  }

  
  /**
   * Remove captcha script
   * @param _renderer Angular's Renderer2 instance used to interact with the DOM.
 * 
   */
  removeCaptchaScript(_renderer: Renderer2) {
    const script = _renderer.selectRootElement("script#g-captcha");

    _renderer.removeChild(document.body, script);
  }
}
